module.exports = __webpack_public_path__ + "static/media/IMG_8021.7cb1a58f.jpg";